import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

const list   = ()           => axios.get(`${API_URL}/api/base-recipes`, auth()).then(r => r.data);
const get    = (id)         => axios.get(`${API_URL}/api/base-recipes/${id}`, auth()).then(r => r.data);
const create = (data)       => axios.post(`${API_URL}/api/base-recipes`, data, auth()).then(r => r.data);
const update = (id, data)   => axios.put(`${API_URL}/api/base-recipes/${id}`, data, auth()).then(r => r.data);
const remove = (id)         => axios.delete(`${API_URL}/api/base-recipes/${id}`, auth()).then(r => r.data);

const baseRecipeService = { list, get, create, update, remove };
export default baseRecipeService;
